<ms-market-help *ngIf="showMarketHelp" [optionGroup]="optionGroup" [eventHelpText]="eventHelpText"></ms-market-help>
<div class="ogp-market-help">
    <ms-market-help *ngIf="displayMultiSelectionText" [optionGroup]="optionGroup" [eventHelpText]="multiSelectionHelpText"></ms-market-help>
</div>
<ms-bet-builder-standard-option-group
    [event]="event"
    [tracking]="tracking"
    [trackingModuleType]="trackingModuleType"
    [sourceOfPick]="sourceOfPick"
    [optionGroup]="optionGroup"></ms-bet-builder-standard-option-group>
